import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';

import { ShareModule} from '../../shared/share.module';

import { AuthGuard } from '../../service/auth-guard.service';

import { UserComponent } from './user/user.component';
import { UserCrudComponent } from './user-crud/user-crud.component';
import { UserListComponent } from './user-list/user-list.component';
import { UsersComponent } from './users/users.component';

import { UserService } from './shared/user.service';

var permissionPage='admin.user';


export const UserServices:Array<any>=[UserService];
export const UserComponents:Array<any>=[UserListComponent,UserComponent,UserCrudComponent,UsersComponent];
export const UserRoutes: Routes = [
  { path: 'user', component: UserListComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'list'  } },
  { path: 'user/create', component: UserCrudComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'create' } },
  { path: 'user/:id', component: UserCrudComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'read' } },
  { path: 'user/:id/update', component: UserCrudComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'update' } },
  { path: 'user/:id/clone', component: UserCrudComponent, canActivate: [AuthGuard], data: { 'fromRoute': true,page:permissionPage, operation: 'clone' } }
];


@NgModule({
  imports: [ ShareModule ],
  declarations: [...UserComponents],
  providers: [UserService],
  exports: [...UserComponents]
})
export class UserModule { }



// WEBPACK FOOTER //
// ./src/app/module/user/user.module.ts